'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('react');
require('@wishket/yogokit');
require('react-dom');
require('../../DataDisplays/Avatar/Avatar.js');
require('../../DataDisplays/Label/Label.js');
require('../../DataDisplays/SystemIcon/Icons/Medium/MediumBell.js');
require('next/link');
var SnackBar = require('../../Feedbacks/SnackBar/SnackBar.js');

/**
 * 스낵바를 포함하는 래퍼 컴포넌트입니다.
 * 자식 컴포넌트 상단에 알림 메시지를 표시할 수 있습니다.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - 래핑될 자식 컴포넌트
 * @param {boolean} props.isOpen - 스낵바 표시 여부
 * @param {string} props.message - 스낵바에 표시될 메시지
 * @param {MessageType} props.type - 스낵바의 타입 (information, success, progress, waiting, caution, error)
 * @param {() => void} props.onClose - 스낵바 닫기 핸들러
 *
 * @example
 * ```tsx
 * <WithSnackBar
 *   isOpen={true}
 *   message="저장되었습니다"
 *   type="success"
 *   onClose={() => setIsOpen(false)}
 * >
 *   <YourComponent />
 * </WithSnackBar>
 * ```
 */ const WithSnackBar = ({ children, isOpen, message, type, onClose })=>{
    return jsxRuntime.jsxs(Box, {
        "data-testid": "design-system-with-message-bar",
        children: [
            jsxRuntime.jsx(Box, {
                className: "w-full overflow-y-hidden",
                children: jsxRuntime.jsx(Box, {
                    className: tailwindMerge.twJoin('w-full transform overflow-y-hidden transition-all duration-300 ease-linear', isOpen ? 'max-h-full translate-y-0' : 'max-h-0 -translate-y-full'),
                    "data-testid": "design-system-with-message-bar--container",
                    children: jsxRuntime.jsx(Box, {
                        className: "pt-8",
                        children: jsxRuntime.jsx(SnackBar, {
                            message: message,
                            type: type,
                            onClose: onClose
                        })
                    })
                })
            }),
            children
        ]
    });
};

module.exports = WithSnackBar;
